document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('[data-open-filters]');
  const summary = document.querySelector('.facets__summary');

  if (trigger && summary) {
    trigger.addEventListener('click', () => {
      summary.click();
    });
  }
});